export const TIP_PROCESSING_FEE_RATE = 0.029;
export const TIP_PROCESSING_FIXED_FEE_CENTS = 50;
export const MIN_TIP_AMOUNT = 1;

export interface TipFeeBreakdown {
  amountCents: number;
  coverProcessingFee: boolean;
  customerTotalCents: number;
  processingFeeCents: number;
  technicianTipCents: number;
}

export function dollarsToCents(amount: number): number {
  return Math.max(0, Math.round(amount * 100));
}

export function centsToDollars(cents: number): number {
  return cents / 100;
}

export function formatCurrency(cents: number): string {
  return `$${centsToDollars(cents).toFixed(2)}`;
}

export function isValidTipAmount(amount: number | null | undefined): amount is number {
  return Number.isFinite(amount) && amount >= MIN_TIP_AMOUNT;
}

export function calculateProcessingFeeCents(chargeAmountCents: number): number {
  if (chargeAmountCents <= 0) return 0;
  return Math.round(chargeAmountCents * TIP_PROCESSING_FEE_RATE) + TIP_PROCESSING_FIXED_FEE_CENTS;
}

export function grossUpForProcessingFeeCents(tipAmountCents: number): number {
  if (tipAmountCents <= 0) return 0;

  const processingFee =
    (tipAmountCents + TIP_PROCESSING_FIXED_FEE_CENTS) /
      (1 - TIP_PROCESSING_FEE_RATE) -
    tipAmountCents;
  return tipAmountCents + Math.round(processingFee);
}

export function getTipFeeBreakdown(amount: number, coverProcessingFee: boolean): TipFeeBreakdown {
  const amountCents = dollarsToCents(amount);
  const customerTotalCents = coverProcessingFee
    ? grossUpForProcessingFeeCents(amountCents)
    : amountCents;
  const processingFeeCents = coverProcessingFee
    ? customerTotalCents - amountCents
    : calculateProcessingFeeCents(customerTotalCents);

  return {
    amountCents,
    coverProcessingFee,
    customerTotalCents,
    processingFeeCents,
    technicianTipCents: coverProcessingFee
      ? amountCents
      : Math.max(0, amountCents - processingFeeCents),
  };
}
